<template>
  <el-button type="primary" @click="onClick">
    {{ editMode ? '保 存' : '提 交' }}
  </el-button>
</template>

<script>
export default {
  name: "SubmitBtn",
  props: {
    editMode: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$emit("onSubmit");
    },
  },
};
</script>

<style lang="less" scoped></style>
